"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Auth = void 0;
var types_1 = require("./types");
var headers_1 = require("../shared/headers");
var client_1 = require("../shared/http/client");
__exportStar(require("./types"), exports);
var Auth = /** @class */ (function () {
    function Auth(apiUrl, appDetails, apiSecurity) {
        this.client = client_1.HttpClient.create(apiUrl, apiSecurity === null || apiSecurity === void 0 ? void 0 : apiSecurity.unauthorizedCallback);
        this.appDetails = appDetails;
        this.apiSecurity = apiSecurity;
        this.apiUrl = apiUrl;
    }
    Auth.client = function (apiUrl, appDetails, apiSecurity) {
        return new Auth(apiUrl, appDetails, apiSecurity);
    };
    /**
     * Tries to register a new user
     * @param registerDetails
     */
    Auth.prototype.register = function (registerDetails) {
        return this.client.post('/register', {
            name: registerDetails.name,
            captcha: registerDetails.captcha,
            lastname: registerDetails.lastname,
            email: registerDetails.email,
            password: registerDetails.password,
            mnemonic: registerDetails.mnemonic,
            salt: registerDetails.salt,
            privateKey: registerDetails.keys.privateKeyEncrypted,
            publicKey: registerDetails.keys.publicKey,
            revocationKey: registerDetails.keys.revocationCertificate,
            referral: registerDetails.referral,
            referrer: registerDetails.referrer,
        }, this.basicHeaders());
    };
    /**
     * Tries to log in a user given its login details
     * @param details
     * @param cryptoProvider
     */
    Auth.prototype.login = function (details, cryptoProvider) {
        return __awaiter(this, void 0, void 0, function () {
            var securityDetails, encryptedSalt, encryptedPasswordHash, keys;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.securityDetails(details.email)];
                    case 1:
                        securityDetails = _a.sent();
                        encryptedSalt = securityDetails.encryptedSalt;
                        encryptedPasswordHash = cryptoProvider.encryptPasswordHash(details.password, encryptedSalt);
                        return [4 /*yield*/, cryptoProvider.generateKeys(details.password)];
                    case 2:
                        keys = _a.sent();
                        return [2 /*return*/, this.client
                                .post('/access', {
                                email: details.email,
                                password: encryptedPasswordHash,
                                tfa: details.tfaCode,
                                privateKey: keys.privateKeyEncrypted,
                                publicKey: keys.publicKey,
                                revocateKey: keys.revocationCertificate,
                            }, this.basicHeaders())
                                .then(function (data) {
                                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                // @ts-ignore
                                data.user.revocationKey = data.user.revocateKey; // TODO : remove when all projects use SDK
                                return data;
                            })
                                .catch(function (error) {
                                throw new types_1.UserAccessError(error.message);
                            })];
                }
            });
        });
    };
    /**
     * Updates the asymmetric keys
     * @param keys
     * @param token
     */
    Auth.prototype.updateKeys = function (keys, token) {
        return this.client.patch('/user/keys', {
            publicKey: keys.publicKey,
            privateKey: keys.privateKeyEncrypted,
            revocationKey: keys.revocationCertificate,
        }, this.headersWithToken(token));
    };
    /**
     * Returns general security details
     * @param email
     */
    Auth.prototype.securityDetails = function (email) {
        return this.client
            .post('/login', {
            email: email,
        }, this.basicHeaders())
            .then(function (data) {
            return {
                encryptedSalt: data.sKey,
                tfaEnabled: data.tfa === true,
            };
        });
    };
    /**
     * Generates a new TwoFactorAuth code
     */
    Auth.prototype.generateTwoFactorAuthQR = function () {
        var _a;
        return this.client
            .get('/tfa', this.headersWithToken((_a = this.apiSecurity) === null || _a === void 0 ? void 0 : _a.token))
            .then(function (data) {
            return {
                qr: data.qr,
                backupKey: data.code,
            };
        });
    };
    /**
     * Disables TwoFactorAuthentication
     * @param pass
     * @param code
     */
    Auth.prototype.disableTwoFactorAuth = function (pass, code) {
        var _a;
        return this.client.delete('/tfa', this.headersWithToken((_a = this.apiSecurity) === null || _a === void 0 ? void 0 : _a.token), {
            pass: pass,
            code: code,
        });
    };
    /**
     * Store TwoFactorAuthentication details
     * @param backupKey
     * @param code
     */
    Auth.prototype.storeTwoFactorAuthKey = function (backupKey, code) {
        var _a;
        return this.client.put('/tfa', {
            key: backupKey,
            code: code,
        }, this.headersWithToken((_a = this.apiSecurity) === null || _a === void 0 ? void 0 : _a.token));
    };
    /**
     * Sends request to send the email to delete the account
     * @param email
     */
    Auth.prototype.sendDeactivationEmail = function (email) {
        return this.client.get("/deactivate/" + email, this.basicHeaders());
    };
    /**
     * Confirms the account deactivation
     * @param token
     */
    Auth.prototype.confirmDeactivation = function (token) {
        return this.client.get("/confirmDeactivation/" + token, this.basicHeaders());
    };
    /**
     * Checks if the password is correct for this email
     * @param email
     * @param hashedPassword
     * @returns
     */
    Auth.prototype.areCredentialsCorrect = function (email, hashedPassword) {
        // Uses fetch instead of httpClient since a 401 response
        // would log out the user
        return fetch(this.apiUrl + "/are-credentials-correct?email=" + email + "&hashedPassword=" + hashedPassword).then(function (res) {
            if (res.ok) {
                return true;
            }
            else if (res.status === 401) {
                return false;
            }
            else
                throw new Error("Request failed with error " + res.status);
        });
    };
    Auth.prototype.basicHeaders = function () {
        return (0, headers_1.basicHeaders)(this.appDetails.clientName, this.appDetails.clientVersion);
    };
    Auth.prototype.headersWithToken = function (token) {
        return (0, headers_1.headersWithToken)(this.appDetails.clientName, this.appDetails.clientVersion, token);
    };
    return Auth;
}());
exports.Auth = Auth;
